import * as React from 'react';

import {Box, Button, Typography} from "@mui/material";

import {formatNumber, formatPercentage, getTrendIcon, getWidth} from "../../../Utils";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

export default function AccordeonPersonna({info, name, items}) {


    const [open, setOpen] = React.useState(false);

    return (
        <Box sx={{width: '100%', display: "flex", flexDirection: "column"}}>

            <Button onClick={() => setOpen(!open)}>

                <Typography> Plus de détails*</Typography>
            </Button>

            {open && <Box sx={{width: '100%', display: "flex", flexDirection: "column", mt: 2}}>
                    {items.map((item, i) => {

                        let keys=Object.keys(info);
                        let values=Object.values(info);
                        let index=keys.indexOf(name);
                        return (<Box key={i} sx={{mb:2}}>
                            <Box sx={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                                <ArrowCircleRightIcon/>
                                <Typography  sx={{textDecoration: 'underline'}} variant={"body2"}> {item}</Typography>
                            </Box>
                            <Typography key={i} variant={"body2"}> {values[index][item]}</Typography>
                            </Box>)
                    })}
            </Box>}

        </Box>
    );

}
